import { render, staticRenderFns } from "./Reparatie.vue?vue&type=template&id=63fc027e&scoped=true"
import script from "./Reparatie.vue?vue&type=script&lang=js"
export * from "./Reparatie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc027e",
  null
  
)

export default component.exports